import React from "react";
import "./navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar mb-5">
      <ul className="navbar__list">
        <li className="navbar__list-item">
          <a href="#home" className="text-decoration-none text-dark">
            Home
          </a>
        </li>
        <li className="navbar__list-item">
          <a href="#features" className="text-decoration-none text-dark">
            Features
          </a>
        </li>
        <li className="navbar__list-item">
          <a href="#contacts" className="text-decoration-none text-dark">
            Contacts
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
